module.exports = __webpack_public_path__ + "static/media/filters-icon.e6e5a96f.png";